import { cloneDeep, isEmpty } from 'lodash';

export default {
  data() {
    return {
      currFilters: {}
    };
  },

  computed: {
    filterData() {
      let filtered = Object.entries(this.currFilters).filter(
        ([, value]) =>
          !(
            value === null ||
            value === '' ||
            (Array.isArray(value) && value.length === 0)
          )
      );

      return Object.fromEntries(filtered);
    }
  },

  mounted() {
    if (!isEmpty(this.filters)) {
      this.currFilters = cloneDeep(this.filters);
    }
    this.setFilters();
  },

  methods: {
    setFilters() {
      this.$emit('setFilters', cloneDeep(this.filterData));
    }
  }
};
